import moment from 'moment'
import axiosIns from '@/libs/axios'

const ROOT_URL = '/ReportPortal/i2Sales'

export default {
  namespaced: true,
  state: {
    loading: false,
    sales: {
      data: [],
      grandTotals: {
        sales: 0,
        connections: 0,
        stocks: 0,
        salesChart: {
          series: [],
          labels: [],
          colors: [],
        },
        stocksChart: {
          series: [],
          labels: [],
          colors: [],
        },
        connectionsChart: {
          series: [],
          labels: [],
          colors: [],
        },
      },
    },
    brands: {
      data: [],
      grandTotals: {
        sales: 0,
        connections: 0,
        stocks: 0,
        chartData: {
          series: [],
          labels: [],
        },
      },
    },
    cumulatives: {
      data: [],
      grandTotals: {
        sales: 0,
        chartData: {
          series: [],
          labels: [],
        },
      },
    },
    buyTypes: {
      data: [],
      grandTotals: {
        sales: 0,
        chartData: {
          series: [],
          labels: [],
        },
      },
    },
    /* Filter Params */
    salesParams: {
      sdate: `${moment().format('YYYY-MM')}-01`,
      edate: moment().format('YYYY-MM-DD'),
    },
    brandsParams: {
      sdate: `${moment().format('YYYY-MM')}-01`,
      edate: moment().format('YYYY-MM-DD'),
    },
    buyTypesParams: {
      sdate: `${moment().format('YYYY-MM')}-01`,
      edate: moment().format('YYYY-MM-DD'),
    },
    cumulativesParams: {
      sdate: '2024-01-01',
      edate: moment().format('YYYY-MM-DD'),
    },
  },
  getters: {
    loading(state) {
      return state.loading
    },
    sales(state) {
      return state.sales
    },
    brands(state) {
      return state.brands
    },
    cumulatives(state) {
      return state.cumulatives
    },
    buyTypes(state) {
      return state.buyTypes
    },
    /* Filter Params */
    salesParams(state) {
      return state.salesParams
    },
    brandsParams(state) {
      return state.brandsParams
    },
    buyTypesParams(state) {
      return state.buyTypesParams
    },
    cumulativesParams(state) {
      return state.cumulativesParams
    },
  },
  mutations: {
    SET_LOADING(state, data) {
      state.loading = data
    },
    SET_SALES(state, data) {
      state.sales = data
    },
    SET_BRANDS(state, data) {
      state.brands = data
    },
    SET_CUMULATIVES(state, data) {
      state.cumulatives = data
    },
    SET_BUY_TYPES(state, data) {
      state.buyTypes = data
    },
    /* RESET MUTATIONS */
    RESET_SALES(state) {
      state.sales = {
        data: [],
        grandTotals: {
          sales: 0,
        },
      }
    },
    RESET_BRANDS(state) {
      state.brands = {
        data: [],
        grandTotals: {
          sales: 0,
          connections: 0,
          stocks: 0,
          salesChart: {
            series: [],
            labels: [],
            colors: [],
          },
          stocksChart: {
            series: [],
            labels: [],
            colors: [],
          },
          connectionsChart: {
            series: [],
            labels: [],
            colors: [],
          },
        },
      }
    },
    RESET_CUMULATIVES(state) {
      state.cumulatives = {
        data: [],
        grandTotals: {
          sales: 0,
        },
      }
    },
    RESET_BUY_TYPES(state) {
      state.buyTypes = {
        data: [],
        grandTotals: {
          sales: 0,
          chartData: {
            series: [],
            labels: [],
          },
        },
      }
    },
  },
  actions: {
    getSales({ commit }, params) {
      commit('SET_LOADING', true)
      commit('RESET_SALES')
      const data = JSON.stringify(params)
      axiosIns
        .post(`${ROOT_URL}/I2Sales`, data)
        .then(response => {
          commit('SET_SALES', response.data)
          commit('SET_LOADING', false)
        })
        .catch(error => console.error(error))
    },
    getBrands({ commit }, params) {
      commit('SET_LOADING', true)
      commit('RESET_BRANDS')
      const data = JSON.stringify(params)
      axiosIns
        .post(`${ROOT_URL}/I2Sales/brands`, data)
        .then(response => {
          commit('SET_BRANDS', response.data)
          commit('SET_LOADING', false)
        })
        .catch(error => console.error(error))
    },
    getCumulatives({ commit }, params) {
      commit('SET_LOADING', true)
      commit('RESET_CUMULATIVES')
      const data = JSON.stringify(params)
      axiosIns
        .post(`${ROOT_URL}/I2Sales/cumulatives`, data)
        .then(response => {
          commit('SET_CUMULATIVES', response.data)
          commit('SET_LOADING', false)
        })
        .catch(error => console.error(error))
    },
    getBuyTypes({ commit }, params) {
      commit('SET_LOADING', true)
      commit('RESET_BUY_TYPES')
      const data = JSON.stringify(params)
      axiosIns
        .post(`${ROOT_URL}/I2Sales/buyTypes`, data)
        .then(response => {
          commit('SET_BUY_TYPES', response.data)
          commit('SET_LOADING', false)
        })
        .catch(error => console.error(error))
    },
  },
}
